import React,{useState, useEffect} from 'react'

function Top() {
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const deadline = "10/30/2023";

  const getTime = () => {
    const time = Date.parse(deadline) - Date.now();

    setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
    setMinutes(Math.floor((time / 1000 / 60) % 60));
    setSeconds(Math.floor((time / 1000) % 60));
  };

  useEffect(() => {
    const interval = setInterval(() => getTime(deadline), 1000);

    return () => clearInterval(interval);
  }, [Date.now()]);

  return (
    <div className=' mb-4 bg-black  flex justify-center text-white w-full py-4'>
        <p className='font-bold text-[13px] pr-[5px] tracking-[.1rem]'>40% rabatt upphör om:</p>
        <div className='flex align-items-center justify-center text-[13px] font-normal'>
            <div className=' ml-[5px] flex align-items-center  justify-center text-[13px] font-normal'>
                <p> {hours} </p>
                <p>H:</p>
            </div>
            <div className='ml-[5px] flex align-items-center  justify-center text-[13px] font-normal'>
                <p> {minutes} </p>
                <p>M:</p>
            </div>
            <div className='ml-[5px] flex align-items-center  justify-center text-[13px] font-normal'>
                <p> {seconds} </p>
                <p> S</p>
            </div>
        </div>
    </div>
  )
}

export default Top